import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var EditFormOutlineSVG = function EditFormOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.8 5.11L26.89 2.2a.67.67 0 00-.48-.2.7.7 0 00-.49.2L21.13 7H4a2 2 0 00-2 2v19a2 2 0 002 2h19a2 2 0 002-2V10.88l4.8-4.8a.68.68 0 000-.97zM23 28H4V9h15.13l-3.5 3.5-4 4a.42.42 0 00-.14.28L11 20.22a.69.69 0 00.19.58.68.68 0 00.49.2l3.54-.5a.42.42 0 00.28-.14l7.5-7.48zm-8.55-9.41l-1.22.18.18-1.22L23.83 7.13l1 1zM26.23 6.82l-1.05-1 1.3-1.3 1.05 1z"
  }));
};
EditFormOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EditFormOutlineSVG);